import styled, { css } from 'styled-components';

export const MainContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  overflow-y: auto;
  flex-direction: column;

  ${({ theme }) =>
    theme.responsive.isMobile &&
    css`
      padding-top: 16px;
    `}
`;

export const ContentContainer = styled.div`
  flex: 1;
  gap: 40px;
  display: flex;

  ${({ theme }) => css`
    ${(theme.responsive.isMobile || theme.responsive.isTablet) &&
    css`
      gap: 24px;
      flex: unset;
      flex-direction: column;
    `}
  `}
`;

export const LeftContainer = styled.div`
  flex: 1;
  gap: 24px;
  display: flex;
  flex-direction: column;
`;

export const RightContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const ImageContainer = styled.div`
  flex: 1;
  overflow: hidden;
  max-width: 620px;
  max-height: 856px;
  border-radius: 16px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
